import React from 'react'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import CompanyStats from '../components/CompanyStatus'
import ServicesSection from '../components/ServicesSection'
import ProjectsCarousel from '../components/ProjectsCarousel'
import OurClientsMarquee from '../components/OurClientsMarquee'
import CallToAction from '../components/CallToAction'

const Home = () => {
  return (
    <div className="font-inter">
        <Hero />
        <CompanyStats />
        <ServicesSection />
        <ProjectsCarousel />
        <OurClientsMarquee />
        <CallToAction />
        <Footer />
    </div>
  )
}

export default Home